// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-98be8a46] .van-tab{font-size:15px;color:#999}[data-v-98be8a46] .van-tab--active{color:#333;font-weight:600}[data-v-98be8a46] .van-tabs__line{display:none}[data-v-98be8a46]::-webkit-scrollbar,[data-v-98be8a46]::-webkit-scrollbar-track{display:none}", ""]);
// Exports
module.exports = exports;
